(function () {
    'use strict';
    angular
        .module('services',['br.cidades.estados', 'ui.router'])
        .config(ServiceConfig)
        .factory('ServiceInterceptor', ['$q', '$location', '$injector', function($q, $location, $injector){
            return {
                request: function(config) {
                    //console.log('Request made with', config);
                    return config;
                },
                requestError: function(rejection) {
                    //console.log('Request error due to ', rejection);
                    return $q.reject(rejection);
                },
                response: function(response) {
                    //console.log('Response from server ', response)
                    return response || $q.when(response);
                },
                responseError: function(rejection) {
                    const regex = /\/integration-api-new\//g;

                    // skip redirect for urls that match the regex above
                    if (rejection.status == 400 && !rejection?.config?.url?.match(regex)) {
                        var stateService = $injector.get('$state');
                        stateService.go('auth.login');
                    }

                    //console.log('Error in response ', rejection)
                    return $q.reject(rejection);
                }
            };
        }]);

        ServiceConfig.$inject = ['$httpProvider'];

        function ServiceConfig($httpProvider) {
            $httpProvider.interceptors.push('ServiceInterceptor');
            //console.log(ServiceInterceptor);
        }
})();